import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData'

function Type() {
  return (
    <SettingsMetaData propertyName={"Type_emp"} viewPropertyName={"Type"} />
)
}

export default Type